import React from "react";

import svg from "../../assets/images/icons/steps/Run Value Table f.svg";

export const RunValueRuleIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Run Value Rule"}
    />
);
